/**
 * Created with IntelliJ IDEA.
 * User: liors
 * Date: 7/21/13
 * Time: 2:57 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Backbone = require("backbone");
    var SurveyModel = require("models/entities/SurveyModel");
    var BaseCollection = require("collections/BaseCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var NAME = "SurveyCollection";

    var SurveyCollection = BaseCollection.extend({
        model: SurveyModel,
        resource: ApiResources.AccountConfig.Survey.Standard,
        name: NAME,
        defaultSurveys: {}, //an object to hold all default surveys per type

        initialize: function(models,options) {
          options = options ||{};
          this.source = options.source;
        },

        parse: function (response) {
            // Iterate over the array of returned values and check for id = -1
            if (_.isArray(response)) {
                _.each(response, function (item, index) {
                  if (-1 === item.id) {
                      // We'll switch the -1 value of the id to the value of the external id
                      item.id = item.externalId;
                  }
                  if (item[this.model.KEYS.DEFAULT_SURVEY]) {  //find all default surveys
                      this.defaultSurveys[item[this.model.KEYS.TYPE]] = item.id;
                  }
                },this);
                window.LE.logger.debug("default Surveys", "SurveyCollection:parse",{defaults: this.defaultSurveys });
            }
            return response;
        },

        fetch: function(options) {
            options = options || {};
            var newOptions;
            if (options.fetchOptions) {
                newOptions = _.extend(options, {
                    data: options.fetchOptions.data
                });
            } else {
                newOptions = options;
            }
            BaseCollection.prototype.fetch.call(this, newOptions);
        },
        setAgentState: function (enabled) {    ////todo remove when Agent survey is saved on the window
            this.agentState = enabled;
        },

        getAgentState: function () {           ////todo remove when Agent survey is saved on the window
            return this.agentState || false;
        },
        setDefaultSurvey:function(model) {
            // filter only survey with the same type
            var filtered = this.getSurveysByType(model.getSurveyType());

            // clear defaults for the filtered surveys only
            filtered.each(function(modelObj) {
                if (modelObj.isDefaultSurvey()) {
                    modelObj.setDefaultSurvey(false);
                }
            });

            // set default
            model.setDefaultSurvey(true);

            this.defaultSurveys[model.getSurveyType()] = model.id;

        },
        getDefaultSurveyByType:function(type) {
            return this.defaultSurveys[type] || ""; //"" was chosen historically as the default id on the window for empty survey.

        },
        getDefaultSurveyPreChatId: function () {
            return this.getDefaultSurveyByType(SurveyModel.VALUES.TYPE.PRE_CHAT);
        },
        getDefaultSurveyPostChatId: function () {
            return this.getDefaultSurveyByType(SurveyModel.VALUES.TYPE.POST_CHAT);
        },
        getDefaultSurveyOfflineId: function () {
            return this.getDefaultSurveyByType(SurveyModel.VALUES.TYPE.OFFLINE);
        },
        getDefaultSurveyAgentId: function () {
            return this.getDefaultSurveyByType(SurveyModel.VALUES.TYPE.AGENT);
        },

        getSurveysByType: function(type) {
            var filtered = this.where({type: type});
            return new Backbone.Collection(filtered);
        }

    });

    SurveyCollection.NAME = NAME;

    return SurveyCollection;
});
